export * from './abstract-quill-toolbar-format-button.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/abstract-quill-toolbar-format-button/index.ts